<template>
    <footer class="footer z-99 place-items-center fixed bottom-0 h-7 border-t border-solid border-lightgrey bg-white pt-1 w-full shadow-2xl" >
        <div class="flex justify-center items-center">
            <h1 class="texts">© {{year}} Crystalline Software Technologies Pvt. Ltd</h1>
        </div>
    </footer>
</template>
<style scoped>
.w-40 {
    width: calc(100% - 170px);
}
.w-10 {
    width: calc(100% - 10px);
}
.z-99{
    z-index: 99;
}
.h-7{
	height:20px;
}
.pt-1{
	padding-top: 2px;
}
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import { emitter } from '../main';
export default defineComponent({
    data():any {
        return {
            isSidebarToggle: true,
            year:''
        };
    },
    mounted() {
        const d = new Date();
        this.year = d.getFullYear();
        emitter.on('toggle-sidebar', (isToggle: any) => {
            this.isSidebarToggle = isToggle;
        });
    }
});
</script>